import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { ThemeToggle } from '../ui/ThemeToggle';
import { Button } from '../ui/Button';
import { NotificationBell } from './NotificationBell';
import styles from './Header.module.css';

export function Header() {
  const { isAuthenticated, user, logout } = useAuth();
  const [mobileOpen, setMobileOpen] = useState(false);

  const closeMobile = () => setMobileOpen(false);

  const handleLogout = async () => {
    closeMobile();
    await logout();
  };

  return (
    <header className={styles.header}>
      <div className={styles.inner}>
        <Link to="/" className={styles.logo}>
          <span className={styles.logoIcon}>N</span>
          Norion
        </Link>

        {/* Desktop navigation */}
        <nav className={styles.desktopNav}>
          {isAuthenticated ? (
            <>
              <NavLink
                to="/dashboard"
                className={({ isActive }) =>
                  `${styles.navLink} ${isActive ? styles.active : ''}`
                }
              >
                Главная
              </NavLink>
              <NavLink
                to="/dashboard/plans"
                className={({ isActive }) =>
                  `${styles.navLink} ${isActive ? styles.active : ''}`
                }
              >
                Подписка
              </NavLink>
              <NavLink
                to="/dashboard/support"
                className={({ isActive }) =>
                  `${styles.navLink} ${isActive ? styles.active : ''}`
                }
              >
                Поддержка
              </NavLink>
            </>
          ) : (
            <NavLink
              to="/#pricing"
              className={styles.navLink}
            >
              Тарифы
            </NavLink>
          )}
        </nav>

        <div className={styles.actions}>
          <ThemeToggle />

          {isAuthenticated && <NotificationBell />}

          {isAuthenticated ? (
            <span className={styles.userName}>{user?.email}</span>
          ) : (
            <div className={styles.authButtons}>
              <Link to="/login">
                <Button variant="secondary" size="sm">
                  Войти
                </Button>
              </Link>
              <Link to="/register">
                <Button variant="primary" size="sm">
                  Регистрация
                </Button>
              </Link>
            </div>
          )}

          {/* Mobile burger */}
          <button
            className={`${styles.burger} ${mobileOpen ? styles.open : ''}`}
            onClick={() => setMobileOpen((prev) => !prev)}
            aria-label="Меню"
            aria-expanded={mobileOpen}
          >
            <span className={styles.burgerLine} />
            <span className={styles.burgerLine} />
            <span className={styles.burgerLine} />
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      <nav className={`${styles.mobileMenu} ${mobileOpen ? styles.open : ''}`}>
        {isAuthenticated ? (
          <>
            <NavLink to="/dashboard" end className={({ isActive }) => `${styles.mobileNavLink} ${isActive ? styles.active : ''}`} onClick={closeMobile}>
              Главная
            </NavLink>
            <NavLink to="/dashboard/plans" className={({ isActive }) => `${styles.mobileNavLink} ${isActive ? styles.active : ''}`} onClick={closeMobile}>
              Тарифы
            </NavLink>
            <NavLink to="/dashboard/guide" className={({ isActive }) => `${styles.mobileNavLink} ${isActive ? styles.active : ''}`} onClick={closeMobile}>
              Инструкции
            </NavLink>
            <NavLink to="/dashboard/referral" className={({ isActive }) => `${styles.mobileNavLink} ${isActive ? styles.active : ''}`} onClick={closeMobile}>
              Рефералы
            </NavLink>
            <NavLink to="/dashboard/support" className={({ isActive }) => `${styles.mobileNavLink} ${isActive ? styles.active : ''}`} onClick={closeMobile}>
              Поддержка
            </NavLink>
            <NavLink to="/dashboard/settings" className={({ isActive }) => `${styles.mobileNavLink} ${isActive ? styles.active : ''}`} onClick={closeMobile}>
              Настройки
            </NavLink>
            {user?.role === 'admin' && (
              <>
                <div className={styles.mobileSectionTitle}>Администрирование</div>
                <NavLink to="/dashboard/admin" end className={({ isActive }) => `${styles.mobileNavLink} ${isActive ? styles.active : ''}`} onClick={closeMobile}>
                  Дашборд
                </NavLink>
                <NavLink to="/dashboard/admin/users" className={({ isActive }) => `${styles.mobileNavLink} ${isActive ? styles.active : ''}`} onClick={closeMobile}>
                  Пользователи
                </NavLink>
                <NavLink to="/dashboard/admin/reports" className={({ isActive }) => `${styles.mobileNavLink} ${isActive ? styles.active : ''}`} onClick={closeMobile}>
                  Обращения
                </NavLink>
                <NavLink to="/dashboard/admin/promocodes" className={({ isActive }) => `${styles.mobileNavLink} ${isActive ? styles.active : ''}`} onClick={closeMobile}>
                  Промокоды
                </NavLink>
                <NavLink to="/dashboard/admin/nodes" className={({ isActive }) => `${styles.mobileNavLink} ${isActive ? styles.active : ''}`} onClick={closeMobile}>
                  Ноды
                </NavLink>
              </>
            )}
            <div className={styles.mobileAuthButtons}>
              <span className={styles.mobileNavLink}>{user?.email}</span>
              <button type="button" className={styles.mobileLogoutButton} onClick={handleLogout}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                  <polyline points="16 17 21 12 16 7" />
                  <line x1="21" y1="12" x2="9" y2="12" />
                </svg>
                Выйти
              </button>
            </div>
          </>
        ) : (
          <>
            <a href="/#pricing" className={styles.mobileNavLink} onClick={closeMobile}>
              Тарифы
            </a>
            <div className={styles.mobileAuthButtons}>
              <Link to="/login" onClick={closeMobile}>
                <Button variant="secondary" size="md" fullWidth>
                  Войти
                </Button>
              </Link>
              <Link to="/register" onClick={closeMobile}>
                <Button variant="primary" size="md" fullWidth>
                  Регистрация
                </Button>
              </Link>
            </div>
          </>
        )}
      </nav>
    </header>
  );
}
